import { render } from "./Questions.vue?vue&type=template&id=1be4c918&scoped=true"
import script from "./Questions.vue?vue&type=script&lang=js"
export * from "./Questions.vue?vue&type=script&lang=js"

import "./Questions.vue?vue&type=style&index=0&id=1be4c918&scoped=true&lang=css"

import exportComponent from "/var/www/html/dgvt/dgvt-fuchs.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1be4c918"]])

export default __exports__